import { render, staticRenderFns } from "./afterSaleOrder.vue?vue&type=template&id=3e8807f6"
import script from "./afterSaleOrder.vue?vue&type=script&lang=js"
export * from "./afterSaleOrder.vue?vue&type=script&lang=js"
import style0 from "./afterSaleOrder.vue?vue&type=style&index=0&id=3e8807f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports